/* moudist theme */
(function () {
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var esc = function (t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; };

  /* ---- mobil menü ---- */
  var burger = $('#mdstBurger'), nav = $('#mdstNav');
  if (burger && nav) burger.addEventListener('click', function () {
    var open = nav.classList.toggle('is-open');
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---- carousel okları ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rail]'); if (!btn) return;
    var rail = document.getElementById(btn.dataset.rail); if (!rail) return;
    rail.scrollBy({ left: Number(btn.dataset.dir) * Math.round(rail.clientWidth * 0.8), behavior: 'smooth' });
  });

  /* ---- ürün grid filtresi ---- */
  var filters = $('[data-product-filters]');
  if (filters) filters.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cat]'); if (!b) return;
    e.preventDefault();
    $$('.mdst-filter', filters).forEach(function (x) { x.classList.remove('is-active'); });
    b.classList.add('is-active');
    $$('[data-product-grid] > [data-cat]').forEach(function (c) {
      c.hidden = !(b.dataset.cat === 'all' || c.dataset.cat === b.dataset.cat);
    });
  });

  /* ---- PDP galeri ---- */
  var pdpMain = $('[data-pdp-main] img');
  $$('[data-pdp-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      if (pdpMain) pdpMain.src = t.dataset.pdpThumb;
      $$('[data-pdp-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });

  /* ---- sepete ekle (ajax) ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.mdst-atc-form'); if (!form) return;
    e.preventDefault();
    var btn = $('button', form), old = btn.innerHTML;
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        btn.textContent = 'Added ✓';
        setTimeout(function () { btn.innerHTML = old; btn.disabled = false; }, 1600);
      })
      .catch(function () { btn.innerHTML = old; btn.disabled = false; });
  });

  /* ================= GLOSSARY ================= */
  var needsGloss = $('[data-gloss-grid]') || $('[data-gloss-teaser]') || $('[data-gloss-product]') || $('[data-gloss-count]');
  if (!needsGloss || !window.MDST) return;

  function typeClass(t) {
    var s = (t || '').toLowerCase();
    if (s.indexOf('probiotic') > -1) return 'mdst-type--probiotic';
    if (s.indexOf('enzyme') > -1)    return 'mdst-type--enzyme';
    if (s === 'base')                return 'mdst-type--base';
    return 'mdst-type--active';
  }
  function card(e) {
    return '<article class="mdst-gloss-card"><h4>' + esc(e.n) + '</h4>' +
      '<div class="mdst-tags"><span class="mdst-type ' + typeClass(e.t) + '">' + esc(e.t) + '</span></div>' +
      '<p>' + esc(e.d) + '</p><span class="mdst-ing-found">Found in: ' + esc(e.f) + '</span></article>';
  }
  function row(e) {
    return '<article class="mdst-card"><div class="mdst-card-body">' +
      '<div class="mdst-tags" style="margin-bottom:4px"><span class="mdst-type ' + typeClass(e.t) + '">' + esc(e.t) + '</span></div>' +
      '<h3 class="mdst-h3">' + esc(e.n) + '</h3><p style="margin-top:6px">' + esc(e.d) + '</p>' +
      '<span class="mdst-ing-found">Found in: ' + esc(e.f) + '</span></div></article>';
  }

  fetch(window.MDST.glossaryUrl).then(function (r) { return r.json(); }).then(function (GLOSS) {
    var sorted = GLOSS.slice().sort(function (a, b) { return a.n.localeCompare(b.n); });
    $$('[data-gloss-count]').forEach(function (el) { el.textContent = GLOSS.length; });

    /* ana sayfa teaser */
    var teaser = $('[data-gloss-teaser]');
    if (teaser) {
      var names = (teaser.dataset.names || '').split(',').map(function (x) { return x.trim(); });
      teaser.innerHTML = names.map(function (n) {
        var g = GLOSS.find(function (x) { return x.n === n; });
        return g ? row(g) : '';
      }).join('');
    }


    /* --- ürünü sözlük anahtarına bağlayan ortak çözümleyici --- */
    var ALL_KEYS = [];
    GLOSS.forEach(function (g) {
      (g.p || []).forEach(function (k) { if (ALL_KEYS.indexOf(k) < 0) ALL_KEYS.push(k); });
    });
    var SYNONYMS = {
      paw:    ['paw', 'nose', 'balm'],
      glove:  ['glove', 'gloves', 'glove wipe', 'cleaning glove', 'pet wipe'],
      dental: ['dental', 'tooth', 'teeth', 'oral', 'breath'],
      hip:    ['hip', 'joint', 'mobility'],
      skin:   ['skin', 'coat', 'omega'],
      digest: ['digest', 'digestive', 'gut', 'probiotic']
    };
    function keyFrom(raw, name) {
      raw  = (raw  || '').toLowerCase();
      name = (name || '').toLowerCase();
      var hay = raw + ' ' + name;
      if (ALL_KEYS.indexOf(raw) > -1) return raw;
      var direct = ALL_KEYS.filter(function (k) { return hay.indexOf(k) > -1; })[0];
      if (direct) return direct;
      for (var k in SYNONYMS) {
        if (ALL_KEYS.indexOf(k) < 0) continue;
        for (var i = 0; i < SYNONYMS[k].length; i++) {
          if (hay.indexOf(SYNONYMS[k][i]) > -1) return k;
        }
      }
      return raw;
    }

    /* ürün sayfası içerik listesi */
    var pIng = $('[data-gloss-product]');
    if (pIng) {
      var key = keyFrom(pIng.dataset.glossProduct, pIng.dataset.glossName);
      var hits = GLOSS.filter(function (g) { return g.p.indexOf(key) > -1; });
      pIng.innerHTML = hits.length ? hits.map(row).join('')
        : '<p class="mdst-empty">Full ingredient list for this product is coming soon.</p>';
    }

    /* A–Z sözlük */
    var grid = $('[data-gloss-grid]'), empty = $('[data-gloss-empty]'), search = $('[data-gloss-search]');
    function renderGloss(q) {
      var t = (q || '').trim().toLowerCase();
      var hits = sorted.filter(function (e) {
        return !t || (e.n + ' ' + e.f + ' ' + e.t + ' ' + e.d).toLowerCase().indexOf(t) > -1;
      });
      grid.innerHTML = hits.map(card).join('');
      if (empty) empty.style.display = hits.length ? 'none' : 'block';
    }
    if (grid) { renderGloss(''); if (search) search.addEventListener('input', function (e) { renderGloss(e.target.value); }); }

    /* ürün seçici panel */
    var picker = $('[data-ing-picker]');
    if (picker) {
      var list = $('[data-ing-list]'), cnt = $('[data-ing-count]'), emptyP = $('[data-ing-empty]');
      var typeBar = $('[data-ing-type-filter]'), current = null, activeType = 'All';

      function renderPanel() {
        var hits = GLOSS.filter(function (g) { return g.p.indexOf(current) > -1; });
        if (activeType !== 'All') hits = hits.filter(function (g) { return g.t === activeType; });
        list.innerHTML = hits.map(row).join('');
        if (emptyP) emptyP.style.display = hits.length ? 'none' : 'block';
      }
      function select(btn) {
        current = keyFrom(btn.dataset.ingKey, btn.dataset.ingName);
        $$('.mdst-ing-prod', picker).forEach(function (x) { x.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var o;
        if ((o = $('[data-ing-name-out]'))) o.textContent = btn.dataset.ingName;
        if ((o = $('[data-ing-cat-out]')))  o.textContent = btn.dataset.ingCat || '';
        if ((o = $('[data-ing-desc-out]'))) o.textContent = btn.dataset.ingDesc || '';
        var all = GLOSS.filter(function (g) { return g.p.indexOf(current) > -1; });
        if (cnt) cnt.textContent = all.length ? all.length + ' ingredients' : 'list coming';
        var types = ['All'].concat(all.map(function (g) { return g.t; })
          .filter(function (v, i, a) { return a.indexOf(v) === i; }));
        activeType = 'All';
        if (typeBar) typeBar.innerHTML = types.map(function (t, i) {
          return '<a class="mdst-filter' + (i === 0 ? ' is-active' : '') + '" data-type="' + esc(t) + '" href="#">' + esc(t) + '</a>';
        }).join('');
        renderPanel();
      }
      picker.addEventListener('click', function (e) {
        var b = e.target.closest('.mdst-ing-prod'); if (b) select(b);
      });
      if (typeBar) typeBar.addEventListener('click', function (e) {
        var b = e.target.closest('[data-type]'); if (!b) return;
        e.preventDefault(); activeType = b.dataset.type;
        $$('.mdst-filter', typeBar).forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active'); renderPanel();
      });
      var first = $('.mdst-ing-prod', picker); if (first) select(first);
    }
  }).catch(function (e) { console.warn('glossary yüklenemedi', e); });
})();
